import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-ink px-4 py-16 sm:py-24" data-id="element-86" data-mp="aujzm9neq52y">
      <div className="mx-auto max-w-4xl" data-id="element-87" data-mp="ftwn8wm3rg6l">
        <SectionHeading dark eyebrow="And I wanted to give you more" title={<>5 <em className="text-gold-light" data-id="element-89" data-mp="1u5bz3mz0dwa">exclusive bonuses</em> to use alongside the Playbook</>} data-id="element-88" data-mp="fsv6qcmbi1hh" />

        <div className="mt-12 space-y-14" data-id="element-90" data-mp="5w8ozwpafqjo">
          {bonuses.map(b => <article key={b.number} className="md:grid md:grid-cols-2 md:items-center md:gap-10" data-id="element-91" data-mp="3o1v50e6hlqom">
              <div className="-mx-4 md:mx-0" data-id="element-92" data-mp="3t0g76j5aukfp">
                <img src={b.image} alt={`${b.title} mockup`} className="w-full rounded-none md:rounded-3xl bg-white" loading="lazy" data-id="element-93" data-mp="3t1hm4ypfrr2p" />
              </div>
              <div className="mt-6 md:mt-0" data-id="element-94" data-mp="1r934m0qt0omt">
                <div className="flex flex-wrap items-center gap-3" data-id="element-95" data-mp="1r8tbw5edk3df">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-gold px-3.5 py-1.5 text-sm font-black uppercase tracking-wider text-ink" data-id="element-96" data-mp="3idmy1v4a13f0">
                    <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="3ddis2z0zvr31" />
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm font-semibold text-white/60" data-id="element-98" data-mp="3n4mvr2l7zpik">
                    Value: <s data-id="element-99" data-mp="2zfkhm4psoest">${b.value}</s> <strong className="text-gold-light" data-id="element-100" data-mp="2zf2bmgdbym7p">Today FREE</strong>
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-3xl font-black leading-tight text-white" data-id="element-101" data-mp="2uhivtc0zi1dn">{b.title}</h3>
                <p className="mt-1 text-lg font-semibold text-gold-light" data-id="element-102" data-mp="38h1tfaw65ubp">{b.subtitle}</p>
                <p className="mt-3 text-[17px] leading-relaxed text-white/70" data-id="element-103" data-mp="33g4a2uzfau8m">{b.description}</p>
                <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-104" data-mp="np004uox2gap">
                  {b.items.map(item => <li key={item} className="flex gap-2" data-id="element-105" data-mp="iqewsmedbgi1">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-106" data-mp="3cjfyzdkyarjg" />
                      <span className="text-[16px] text-white" data-id="element-107" data-mp="3hgya9amfxium">{item}</span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <SectionCta dark label="Claim my 5 free bonuses" data-id="element-108" data-mp="3qheb0cbsubvs" />
      </div>
    </section>;
}